'use strict'

import Player from './lib/Player/Player';
import YoutubePlayer from './lib/Player/YoutubePlayer';
import VimeoPlayer from './lib/Player/VimeoPlayer';
import FilePlayer from './lib/Player/FilePlayer';

class ModalVideo{
    constructor(){
        this.mainVideo = document.getElementById('modal_video');
        this.mainImage = document.getElementById('modal_image');

        this._videoTag = this.mainVideo.querySelector('.modal-media-video-tag');
        this._videoIframe = this.mainVideo.querySelector('.modal-media-video-iframe');
        this._image = this.mainImage.querySelector('.modal-media-image');

        this._closeBtnVideo = this.mainVideo.querySelector('.close_btn');
        this._closeBtnImage = this.mainImage.querySelector('.close_btn');

        var that = this;

        document.addEventListener('click',function(e){
            if(e.target && e.target.classList.contains('close-video')){
                //console.log('heeere23');
                that._onClickCloseBtn('video');
            } else if(e.target && e.target.classList.contains('close-image')){
                that._onClickCloseBtn('image');
            }
        });
    }

    show(source, type){
        //console.log('ModalVideo:type:', type);
        if(type=='image') {
            this._image.src = source;
            this.mainImage.classList.add('modal--show');
            this.mainImage.classList.add('modal--anim');
        } else if (type=='video-file') {
            this._videoTag.src = source;
            this.mainVideo.classList.add('modal--show');
            this.mainVideo.classList.add('modal--anim');
            this._videoIframe.classList.add('d-none');
            this._videoTag.classList.remove('d-none');
        } else if (type=='video-url') {
            //this._videoIframe.src = source;
            this.mainVideo.classList.add('modal--show');
            this.mainVideo.classList.add('modal--anim');
            this._videoTag.classList.add('d-none');
            this._videoIframe.classList.remove('d-none');

            let vid = new Player(
                source.indexOf('www.youtube.com') !== -1 
                ? new YoutubePlayer ('i-vide-player') 
                : ( source.indexOf('vimeo.com') !== -1 
                    ? new VimeoPlayer ('i-vide-player') 
                    : new FilePlayer('i-vide-player') )
            );
            //console.log('vid:', vid);
            vid.showTitle(false).source(source).mute().play();
            this._closeBtnVideo.addEventListener('click',(e) => {
                //console.log('ENTRO:', vid);
                vid.stop();
                this._videoIframe.removeAttribute('data-ready');
            });
            return vid;
        }

        this.currentTime = 0;

        if(type=='video-file') {
            var that = this;
            setTimeout(()=>{
                that.mainVideo.classList.add('modal--anim');
                that._video.play();
            }, 100)
        }
    }

    _onClickCloseBtn(type){
        //console.log('cerrar - ' + type);
        if(type=='video-file') {
            this._video.pause();
        }

        //console.log('heeere24');

        if(type=='image') {
            this.mainImage.classList.remove('modal--show');
            this.mainImage.classList.remove('modal--anim');
        } else if (type=='video') {
            this.mainVideo.classList.remove('modal--show');
            this.mainVideo.classList.remove('modal--anim');
        }

        setTimeout(()=>{
            if(type=='image') {
                this.mainImage.classList.remove('modal--show');
            } else if (type=='video-url' || type=='video-file') {
                this.mainVideo.classList.remove('modal--show');
            }
        }, 750)
    }
}

export default ModalVideo;